<template>
  <div class="login-wrapper">
       <Alteration/>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Alteration from '../../components/user/Alteration'
export default {
  components:{
    Alteration
  },
  data() {
    return {
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.login-wrapper{
    max-width: 500px;
    margin: 50px auto;
    background: #ffffff99;
    padding: 20px;
    box-shadow: #b48ef1 0 0 10px 3px;
}
</style>